import { vesselTrackOptions } from '~types/vessel.types'

export enum SORT_BY_FILTER {
  NEWEST = 'newest',
  OLDEST = 'oldest',
  NAME = 'name',
}

export interface Filters {
  opsCircles: string[] | null
  poolPartnerNames: string[] | null
  pools: string[] | null
  sortBy: SORT_BY_FILTER | null
  status: StatusFilterOptionValue
}

export const statusFilterOptionValues = [
  '',
  'onboarded',
  'onboarding',
  'archived',
  'incoming',
  'commercial-management',
  'outside-pool',
  'tc-out',
] as const
export type StatusFilterOptionValue = (typeof statusFilterOptionValues)[number]

export const trackFilterOptionValues = [
  'All',
  ...vesselTrackOptions.map(({ label }) => label),
] as const

export type TrackFilterOptionValue = (typeof trackFilterOptionValues)[number]

export enum FilterParamNameEnum {
  favorites = 'favoritesEnabled',
  poolPartnerName = 'poolPartnerName',
  opsDesk = 'opsDesk',
  pool = 'pool',
  sortBy = 'sortBy',
  status = 'status',
  vesselName = 'vesselName',
  harryPotterTheme = 'harry-potter-theme',
}
